/*
 * @Author: limin
 * @Date: 2019-08-31 12:44:16
 * @Last Modified by:   limin
 * @Last Modified time: 2019-08-31 12:44:16
 */

import Vue from 'vue'
import focus from './src/focus'
import clearEmoij from './src/clearEmoij'

Vue.directive(focus.name, focus)
Vue.directive(clearEmoij.name, clearEmoij)
